import i18n from 'config/i18n';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

const t = i18n.getFixedT(getLocale(), 'common');

const schema = yup.object({
  accounts: yup
    .array()
    .of(
      yup.object().shape({
        accountId: yup
          .number()
          .nullable()
          .required(t('validation.valueIsRequired')),
        valid: yup.object({
          from: yup
            .date()
            .required(t('validationFieldRequired', { name: t('validFrom') }))
            .nullable()
            .default(null),
          to: yup
            .date()
            .nullable()
            .required(t('validationFieldRequired', { name: t('validTo') }))
            .default(null)
            .min(yup.ref<Date>('from'))
        })
      })
    )
    .default([{}])
});

export default schema;
